export default "__VITE_ASSET__DtSOwROe__"